import { DEFAULT_SECURITY_COLOR, TECH_CHART_SECURITY_KEYS, TECHNICAL_KEYS, } from 'ChartApp/ts/features/tech-chart/constants';
import { ChartType, TechnicalKey } from 'ChartApp/ts/enums/tech-chart-common.enum';
import { parseFlattenedObject } from 'Angular/utils/urls';
class TechnicalCustomDeserializer {
}
TechnicalCustomDeserializer.color = (_color) => decodeURIComponent(_color);
TechnicalCustomDeserializer.params = (urlValue) => {
    if (urlValue === '')
        return [];
    const flattenedParamIsArray = urlValue.startsWith('(') && urlValue.endsWith(')');
    if (flattenedParamIsArray) {
        const paramVals = urlValue.slice(1, urlValue.length - 1).split(',');
        return [paramVals.map((v) => Number(v))];
    }
    return urlValue.split(',').map((flattenedParam) => {
        const paramAsNum = Number(flattenedParam);
        // eslint-disable-next-line no-restricted-globals
        return isNaN(paramAsNum) ? flattenedParam : paramAsNum;
    });
};
function deserializeTechnical(technicalParamStr) {
    const technicalParamStrs = technicalParamStr.split(',,');
    const flattenedTechnical = {};
    technicalParamStrs
        .filter((s) => s.length)
        .forEach((paramStr) => {
        const [key, value] = paramStr.split('::');
        flattenedTechnical[key] = value;
    });
    const technical = parseFlattenedObject(flattenedTechnical, Object.values(TechnicalKey), TechnicalCustomDeserializer);
    if (Object.keys(technical).length !== TECHNICAL_KEYS.length)
        return undefined;
    return technical;
}
export class TechChartUrlDeserializer {
}
TechChartUrlDeserializer.chartAnnotations = (urlValue) => {
    if (!urlValue)
        return [];
    return urlValue.split(',').filter((annotation) => !!annotation);
};
TechChartUrlDeserializer.chartId = (urlValue) => {
    if (!urlValue)
        return undefined;
    return Number(urlValue);
};
// Do not try to parse the value for zoom because it can be '1' or '6m' and we don't want the '1' to be parsed
// as an int.
TechChartUrlDeserializer.zoom = (urlValue) => decodeURIComponent(urlValue).toString();
// Chart title and note should always be a string. Without this override, titles including ',' will be parsed
// as arrays by parseFlattenedObject
TechChartUrlDeserializer.title = (urlValue) => urlValue.toString();
TechChartUrlDeserializer.note = (urlValue) => urlValue.toString();
TechChartUrlDeserializer.technicals = (urlValue) => {
    const serializedTechnicals = urlValue.split(',,,');
    return serializedTechnicals.map(deserializeTechnical).filter((technical) => !!technical);
};
TechChartUrlDeserializer.security = (urlValue) => {
    const keyValueDelim = ':::';
    const propertyDelim = ',,,';
    if (!urlValue) {
        return null;
    }
    const itemProperties = urlValue.split(propertyDelim);
    if (itemProperties.length !== TECH_CHART_SECURITY_KEYS.length)
        return null;
    const security = { id: '', color: '' };
    itemProperties.forEach((itemProperty) => {
        const [key, value] = itemProperty.split(keyValueDelim);
        if (TECH_CHART_SECURITY_KEYS.includes(key)) {
            security[key] = value;
        }
    });
    if (!security.color) {
        security.color = DEFAULT_SECURITY_COLOR;
    }
    else {
        security.color = decodeURIComponent(security.color);
    }
    if (!security.id) {
        return null;
    }
    security.id = decodeURIComponent(security.id);
    return security;
};
TechChartUrlDeserializer.chartType = (urlValue) => {
    if (Object.values(ChartType).includes(urlValue)) {
        return urlValue;
    }
    return ChartType.INTERACTIVE;
};
